// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__OYoYH","socialList":"Footer_socialList__HzTIh","nav":"Footer_nav__x6jKM","navTitle":"Footer_navTitle__yuv8p","navList":"Footer_navList__v3ula"};